module.exports = __webpack_public_path__ + "img/vipinfosbgsj.733069b6.png";